import styles from './DocumentStatus.module.scss';

import CheckOK from '@src/assets/CheckOK.png';
import Warning from '@src/assets/Warning.png';
import Danger from '@src/assets/Danger.png';
import Plus from '@src/assets/Plus.png';

import { StatusType, DocumentType } from '@src/utilities/types';
import { getDocumentStatusColor } from '@src/utilities/functions';
import { useRef } from 'react';

const statusIcons: Record<string, { src: string; width: string; height: string }> = {
    accepted: { src: CheckOK, width: '22px', height: '16px' },
    pending: { src: Warning, width: '22px', height: '22px' },
    refused: { src: Danger, width: '18px', height: '18px' },
    error: { src: Danger, width: '18px', height: '18px' },
};

type DocumentStatusProps = {
    fileName: string;
    status: StatusType;
    message: string;
    type: DocumentType;
    modifyFile: (file: File) => void;
}

const DocumentTypeLabels: Record<DocumentType, string> = {
    [DocumentType.frontBack]: 'Pièce d’identité',
    [DocumentType.front]: 'Pièce d’identité Recto',
    [DocumentType.back]: 'Pièce d’identité Verso',
    [DocumentType.address]: 'Justificatif de domicile',
    [DocumentType.id]: 'Pièce d’identité'
};

const DocumentStatus: React.FC<DocumentStatusProps> = ({ fileName, status, message, type, modifyFile }) => {
    const color = getDocumentStatusColor(status as StatusType);
    const { src: iconSrc, width, height } = statusIcons[status];

    const fileInputRef = useRef<HTMLInputElement>(null);
    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const _handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            const file = files[0];
            modifyFile(file);
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.topContainer}>
                <div className={styles.icon}>
                    <svg viewBox="0 0 23 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M12.1389 0C12.4917 0 12.7778 0.284913 12.7778 0.636364V6.36364C12.7778 8.47235 14.494 10.1818 16.6111 10.1818H22.3611C22.7139 10.1818 23 10.4667 23 10.8182V24.1818C23 26.2906 21.2838 28 19.1667 28H3.83333C1.71625 28 0 26.2906 0 24.1818V3.81818C0 1.70946 1.71625 0 3.83333 0H12.1389ZM12.4035 13.1001C11.9045 12.6031 11.0955 12.6031 10.5965 13.1001L6.76314 16.9182C6.26414 17.4152 6.26414 18.2211 6.76314 18.7181C7.26215 19.2151 8.07119 19.2151 8.5702 18.7181L10.2222 17.0726V21.6364C10.2222 22.3393 10.7943 22.9091 11.5 22.9091C12.2057 22.9091 12.7778 22.3393 12.7778 21.6364V17.0726L14.4298 18.7181C14.9288 19.2151 15.7379 19.2151 16.2369 18.7181C16.7358 18.2211 16.7358 17.4152 16.2369 16.9182L12.4035 13.1001ZM15.3333 0.218362C15.3333 0.0977708 15.4315 0 15.5526 0C16.2303 0 16.8803 0.268176 17.3596 0.745551L22.2515 5.61809C22.7308 6.09546 23 6.7429 23 7.418C23 7.53859 22.9019 7.63636 22.7807 7.63636H16.6111C15.9054 7.63636 15.3333 7.06654 15.3333 6.36364V0.218362Z" fill="var(--color-a)"/>
                    </svg>
                </div>
                <div className={styles.title}>
                    <strong>{fileName}</strong>
                    <span>{DocumentTypeLabels[type]}</span>
                </div>
                <div className={styles.status}>
                    <p style={{ margin: 'auto', color }}>{message}</p>
                    <img
                        style={{ width, height }}
                        src={iconSrc}
                        alt="Status Icon"
                    />
                </div>
            </div>
            {[StatusType.refused, StatusType.error].includes(status) ?
                <div className={styles.uploadArea}>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <div className={styles.dropZone}>
                            <div className={styles.dropZoneContent}>
                                <p className={styles.dropZoneTitle}>Télécharger un nouveau document</p>
                                <p className={styles.dropZoneText}>Glisser - déposer  maximum 10 Mo</p>
                            </div>
                            <button type="button" className={styles.dropZoneButton} onClick={handleButtonClick}>
                                <img src={Plus} alt="Plus" width={30} height={30} />
                            </button>
                        </div>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".pdf,image/png,image/jpeg"
                            className={styles.fileInput}
                            onChange={_handleFileChange}
                        />
                    </div>
                </div>
                : null}
        </div>
    );
};

export default DocumentStatus;
